import React, {useState, useEffect} from 'react';
import 'fontsource-roboto';
import {makeStyles} from '@material-ui/core/styles';
import useIsMountedRef from './../Components/useIsMountedRef';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import InputAdornment from '@material-ui/core/InputAdornment';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Fab from '@material-ui/core/Fab';

import SearchIcon from '@material-ui/icons/Search';
import CheckIcon from '@material-ui/icons/Check';

import Warning from '../Components/Warning';

const useStyles = makeStyles(theme => ({
  divider: {
    margin: theme.spacing(.5, 0)
  },
  link: {
    textDecoration: 'initial',
    color: 'inherit',
    '&:active': {
      color: 'inherit'
    }
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    margin: theme.spacing(0.5)
  },
  cardHeader: {
    padding: theme.spacing(1, 2, 1)
  },
  avatarPrimary: {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main
  },
  avatarSecondary: {
    color: theme.palette.secondary.contrastText,
    backgroundColor: theme.palette.secondary.main
  },
  cardContent: {
    flexGrow: 1,
    padding: theme.spacing(1),
    '&:last-child': {
      paddingBottom: theme.spacing(1)
    }
  },
  fab: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2)
  },
  fabIcon: {
    marginRight: theme.spacing(1)
  }
}));

export default function Consumables(props) {
  const classes = useStyles();
  const ajax = props.ajax;

  const isMountedRef = useIsMountedRef();

  const [isLoaded, setIsLoaded] = useState(false);
  const [filter, setFilter] = useState({
    text: ''
  });
  const [idPartner, setIdPartner] = useState(Boolean(props.user.idPartner) ? props.user.idPartner : '');
  const [data, setData] = useState([]);

  useEffect(() => {
    setIsLoaded(false);
    ajax('resellerConsumables', {
      idPartner: Boolean(props.user.idPartner) ? props.user.idPartner : idPartner
    })
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok) {
          setData(response.data);
          if (response.data.partners.length === 1)
            setIdPartner(response.data.partners[0].id);
        }

        setIsLoaded(true);
      });
  }, [props.user.idPartner, idPartner]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleFilterChange = e => {
    setFilter({
      ...filter,
      [e.target.name]: e.target.type === 'checkbox' ? e.target.checked : e.target.value !== null ? e.target.value : ''
    });
  };

  const filterData = item => true
      && (
           !!~item.consumable.toLowerCase().indexOf(filter.text.toLowerCase())
      );

  const handleConsumableAdd = (e, value, reason) => {
    switch (reason) {
      case 'select-option':
        setData({...data, consumables: data.consumables.map(item => item.id === value.id ? {...item, isEditable: '1'} : item)});
        break;
      default:
        break;
    };
  };

  const handleDataChange = (idConsumable, quantity) => {
    setData({...data, consumables: data.consumables.map(item => item.id === idConsumable ? {...item, quantity: quantity} : item)});
  };

  const handleConsumablesSave = () => {
    setIsLoaded(false);
    ajax('resellerConsumablesSave', {
      idPartner: Boolean(props.user.idPartner) ? props.user.idPartner : idPartner,
      consumables: data.consumables.filter(consumable => Boolean(parseInt(consumable.isEditable)) && Boolean(parseInt(consumable.quantity)))
    })
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok)
          setData(response.data);

        setIsLoaded(true);
      });
  };

  return (
    <Container maxWidth='md'>
      <Typography variant='h6'>Consumabile</Typography>
      <Typography variant='subtitle2'>Sunt afisati toate consumabilele folosite pentru recoltare.</Typography>
      <Divider className={classes.divider} />

      {!isLoaded &&
        <Box display='block' align='center'>
          <CircularProgress />
        </Box>
      }

      {isLoaded && data.consumables.length === 0 &&
        <Warning variant='subtitle2' align='center'>Nu exista nici o inregistrare care sa corespunda conditiilor cerute.</Warning>
      }

      {isLoaded && data.consumables.length > 0 &&
        <Grid container spacing={1}>
          <Grid item xs={12} sm={6}>
            <TextField margin='none' select disabled={Boolean(props.user.idPartner)}
              label='Partener'
              placeholder='Partener'
              value={idPartner}
              onChange={e => setIdPartner(e.target.value)}
            >
              {data.partners.map(partner => (
                <MenuItem key={partner.id} value={partner.id}>
                  {partner.partner}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField margin='none' autoComplete='off'
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>
                    <SearchIcon />
                  </InputAdornment>
                )
              }}
              label='Filtrare rapida'
              placeholder='Filtrare rapida'
              name='text'
              value={filter.text}
              onChange={handleFilterChange}
            />
          </Grid>
        </Grid>
      }

      {isLoaded && data.consumables.length > 0 && data.consumables.filter(filterData).length === 0 &&
        <Warning variant='subtitle2' align='center'>Nu exista nici o inregistrare care sa corespunda filtrelor aplicate.</Warning>
      }

      {isLoaded && !Boolean(props.user.idPartner) && Boolean(idPartner) &&
        <Grid container alignItems='stretch'>
          <Grid item xs={12}><Typography variant='subtitle1'>Lista consumabile</Typography></Grid>
          <Grid item xs={12}>
            <Autocomplete clearOnBlur={true} blurOnSelect className={classes.infoLight}
              key={JSON.stringify(data.consumables).split('').reduce((a,b)=>{a=((a<<5)-a)+b.charCodeAt(0);return a&a},0)}
              options={data.consumables.filter(item => !Boolean(parseInt(item.isEditable)))}
              getOptionLabel={item => `${item.consumable} (${item.stock} in stoc)`}
              renderInput={params => <TextField {...params} label='Adaugati un consumabil' />}
              onChange={handleConsumableAdd}
            />
          </Grid>

          {data.consumables.filter(item => Boolean(parseInt(item.isEditable))).filter(filterData).map(item =>
            <Grid key={item.id} item xs={12} sm={6} md={4} style={{display: 'flex'}}>
              <Card className={classes.card}>
                <CardHeader className={classes.cardHeader} style={{flexGrow: 1}}
                  title={<Typography variant='subtitle2'>{item.consumable}</Typography>}
                  subheader={<Typography>In stoc partener: {item.stock}</Typography>}
                />
                <CardContent className={classes.cardContent} style={{flexGrow: 0}}>
                  <Box style={{display: 'flex'}}>
                    <Typography color='textSecondary' style={{flexGrow: 1, whiteSpace: 'nowrap'}}>De trimis:</Typography>
                    <Typography color='primary' align='right' component='div'>
                      <TextField color='primary' margin='none' autoComplete='off' autoFocus
                        inputProps={{
                          style: {
                            maxWidth: '60px',
                            padding: '1px 4px',
                            textAlign: 'right',
                            fontSize: '0.875rem',
                            color: '#3f51b5'
                          }
                        }}
                        placeholder='Cantitate'
                        name='quantity'
                        value={item.quantity}
                        onChange={e => handleDataChange(item.id, e.target.value)}
                        onFocus={e => e.target.select()}
                      />
                    </Typography>
                    <Typography color='primary' align='right'> buc</Typography>
                  </Box>
                </CardContent>
                <CardActions disableSpacing></CardActions>
              </Card>
            </Grid>
          )}
        </Grid>
      }

      {isLoaded && Boolean(props.user.idPartner) &&
        <Grid container alignItems='stretch'>
          <Grid item xs={12}><Typography variant='subtitle1'>Lista consumabile</Typography></Grid>
          {data.consumables.filter(filterData).map(item =>
            <Grid key={item.id} item xs={12} sm={6} md={4} style={{display: 'flex'}}>
              <Card className={classes.card}>
                <CardContent className={classes.cardContent} style={{flexGrow: 0}}>
                  <Box style={{display: 'flex'}}>
                    <Typography variant='subtitle2' style={{flexGrow: 1, whiteSpace: 'nowrap'}}>{item.consumable}</Typography>
                    <Typography variant='subtitle2' align='right' component='div'>{item.stock} buc</Typography>
                  </Box>
                </CardContent>
                <CardActions disableSpacing></CardActions>
              </Card>
            </Grid>
          )}
        </Grid>
      }

      {isLoaded &&
        <Fab className={classes.fab}
          disabled={false
            // || !Boolean(idPartner)
            || data.consumables.filter(consumable => Boolean(parseInt(consumable.isEditable)) && Boolean(parseInt(consumable.quantity))).length === 0
          }
          onClick={handleConsumablesSave}
        >
          <CheckIcon />
        </Fab>
      }
    </Container>
  );
}